export const VehicleIndexSceneTranslation = {
  fi: {
    VehicleIndexScene: {
      title: 'Ajoneuvot',
      filterGroup: 'Ryhmä',
    },
  },
};
